import { MenuItemType } from './MenuItemType';
import { Mapper, ReadOnly } from 'module/Common';

export type MenuItemExternalLink = ReadOnly<MenuItemExternalLink.Shape>;

export namespace MenuItemExternalLink {
  export interface Shape {
    type: MenuItemType;
    url: string;
    name: string;
    newTab: boolean;
  }

  const create = (input: MenuItemExternalLink) => input;

  export const mapper = Mapper.mapSchema(
    {
      acf_fc_layout: Mapper.exact(MenuItemType.ExternalLink),
      link: Mapper.mapSchema(
        {
          url: Mapper.str,
          title: Mapper.str,
          target: Mapper.str,
        },
        a => a
      ),
    },
    ({ link, acf_fc_layout }) =>
      create({ url: link.url, name: link.title, newTab: link.target === '_blank', type: acf_fc_layout })
  );

  export const getName = (model: MenuItemExternalLink): string => {
    const name = model.name;
    if (name.length === 0) {
      return getUrl(model);
    }
    return name;
  };
  export const getUrl = (model: MenuItemExternalLink): string => model.url;
  export const newTab = (model: MenuItemExternalLink): boolean => model.newTab;
}



// WEBPACK FOOTER //
// ./src/module/Model/Menu/item/MenuItemExternalLink.ts